function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        var _ref;

        return _ref = {
            sendTo: '',
            buttonState: 'disabled',
            subject: '',
            selectedTemplate: false,
            violationType: '',
            message: ''
        }, _defineProperty(_ref, 'subject', ''), _defineProperty(_ref, 'persons', []), _defineProperty(_ref, 'buildings', []), _defineProperty(_ref, 'units', []), _defineProperty(_ref, 'persons', []), _defineProperty(_ref, 'templates', []), _defineProperty(_ref, 'typeOptions', []), _defineProperty(_ref, 'customToolbar', [["bold", "italic"], [{ list: "bullet" }], ['clear']]), _defineProperty(_ref, 'types', [{
            label: 'Individual',
            value: 'Person'
        }, {
            label: 'Property',
            value: 'Property'
        }, {
            label: 'Building',
            value: 'Building'
        }, {
            label: 'Unit',
            value: 'Unit'
        }, {
            label: 'Everyone',
            value: 'Everyone'
        }, {
            label: 'Create Template',
            value: 'Create Template'
        }]), _defineProperty(_ref, 'individuals', []), _defineProperty(_ref, 'properties', []), _defineProperty(_ref, 'buildings', []), _defineProperty(_ref, 'units', []), _ref;
    },

    computed: {
        appType: function appType() {

            var theType = null;

            switch (this.sendTo) {
                case 'Person':
                    theType = 'API\\Person';
                    break;
                case 'Property':
                    theType = 'Property';
                    break;
                case 'Building':
                    theType = 'Building';
                    break;
                case 'Unit':
                    theType = 'Unit';
                    break;
                case 'Everyone':
                    theType = 'Everyone';
                    break;
                default:
                    // null that jawn
                    break;
            }

            return theType;
        }
    },
    methods: {
        getTemplates: function getTemplates() {

            // console.log('test')

            var self = this;

            window.axios.get('/prototype/notifications/templates').then(function (response) {

                var notes = response.data,
                    outputData = [];

                notes.forEach(function (n, index) {

                    var item = {
                        label: n.subject,
                        value: n.id
                    };

                    outputData.push(item);
                });

                self.templates = outputData;
            });
        },
        getSendToObjects: function getSendToObjects(type) {
            var self = this;

            self.sendTo = type;

            this.recipientId = null;

            this.$nextTick(function () {
                if (self.sendTo) {

                    window.axios.post('/prototype/notifications/new-api', {
                        type: self.sendTo
                    }).then(function (response) {
                        self.typeOptions = response.data;
                    });
                }
            });
        },
        submitNotification: function submitNotification() {

            var self = this,
                units = [],
                buildings = [],
                properties = [],
                persons = [];

            this.units.forEach(function (item, index) {
                units.push(item.value);
            });

            this.buildings.forEach(function (item, index) {
                buildings.push(item.value);
            });

            this.properties.forEach(function (item, index) {
                properties.push(item.value);
            });

            this.persons.forEach(function (item, index) {
                persons.push(item.value);
            });

            var sendData = {
                body: this.message,
                subject: this.subject,
                template: this.sendTo == 'Create Template',
                units: units,
                buildings: buildings,
                properties: properties,
                persons: persons
            };

            window.axios.post('/prototype/notifications/create', sendData).then(function (response) {
                self.$snotify.success('The notification is queued to send');
                Event.$emit('refetch-notifications');
                Event.$emit('close-full-modal');
                self.selectedTemplate = false;
                self.subject = '';
                self.sendTo = '';
                self.typeOptions = [];
                self.persons = [];
                self.buildings = [];
                self.units = [];
                self.persons = [];
                self.templates = [];
                self.typeOptions = [];
            });
        },
        createNotification: function createNotification() {

            var self = this;

            var note = {
                body: this.message,
                subject: this.subject,
                recipient_id: this.recipientId,
                recipient_type: this.sendTo
            };

            window.axios.post('/prototype/notifications/store', note).then(function (response) {

                Event.$emit('close-full-modal');
            });
        }
    },
    watch: {
        selectedTemplate: function selectedTemplate() {
            var _this = this;

            var $el = this;
            window.axios.post('/prototype/notifications/view', {
                id: this.selectedTemplate.value
            }).then(function (response) {

                $el.message = response.data[0].body;
                $el.message = $el.message.replace(/</g, "*");
                $el.message = $el.message.replace(/>/g, "*");
                _this.$data.subject = response.data[0].subject;
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        var $el = this;

        Event.$on('new-notification', function () {
            _this2.getTemplates();
            $el.$children[0].$data.showModal = true;
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('new-notification');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/notifications/NewNotification.vue
// module id = /8i/
// module chunks = 0 1